import { useCallback, useState } from "react";
import Button from "@/components/forms/Button/Button";
import IconArrow from "@/components/icons/IconArrow";
import IconCheckCircle from "@/components/icons/IconCheckCircle";
import IconLock from "@/components/icons/IconLock";
import { useLocation, useSearch } from "wouter";
import { ErrorCode } from "@boxem/core-api-schema";
import { useIntercom } from "react-use-intercom";
import { useUserContext } from "@/contexts/UserContext";
import styles from "./page.module.css";
import Flex from "@/components/Flex/Flex";
import Alert from "@/components/Alert/Alert";
import { Modal } from "@/components/Modal/Modal";


export default function ConnectSellerApiPage() {
  const searchParams = new URLSearchParams(useSearch());
  const failed = searchParams.get('failed') === 'true';

  const errorMsg = searchParams.get('error') === ErrorCode.SELLER_ID_IN_USE ? 
    'The Seller ID you attempted to connect is already in use by another account. If you need to migrate your Seller ID, or lost access to your old account, please ' 
    : 'Failed to connect seller central. Please try again later. If the error persists, please';
  const [isOpen, setIsOpen] = useState(failed ? false: true);

  const intercom = useIntercom();
  const {user} = useUserContext();
  const [location, navigate] = useLocation();

  const handleConnect = () => {
    const redirectUri = encodeURIComponent(`${window.location.origin}/connect/seller-api/succeed`);
    window.location.href = `https://sellercentral.amazon.com/apps/authorize/consent?application_id=${process.env.PUBLIC_AWS_SELLER_APP_ID}&state=test&version=beta&redirect_uri=${redirectUri}`;
  };

  const showHelpChat = useCallback(() => {
    sessionStorage.setItem("show-intercom", "true");
    try {
      intercom.update({ name: user?.name, hideDefaultLauncher: false });
      intercom.show();
    } catch (err) {
      console.error(err);
    }
  }, [intercom, user]);
  
  return (
    <>
      {!isOpen && <Flex direction="column" align="center" style={{padding: '2rem'}}>
        <Alert type="error" message={errorMsg} showSupport={true} showHelpChat={showHelpChat} />
        <Button onClick={() => setIsOpen(true)}>Connect</Button>
      </Flex> }
      {isOpen && <div className={styles.container}>      
        <Modal
          open={isOpen}
          onOpenChange={open => {
            if (!open) navigate("/");
          }}
        >
          <div className={styles.modalHeader}>
            <img src="/images/illustration-1.svg" width={330} height={238} alt="illustration" />
          </div>

          <div className={styles.modalBody}>
            <Flex direction="column" gap={4}>
              <h3>Connect to Amazon</h3>
              <p>
                You’re almost there! To make the magic happen, connect your Amazon account to Boxem. This will enable us
                to help you manage your inventory, analyze performance, and more — all in one place.
              </p>
              <Flex direction="column" gap={2}>
                {[
                  { text: "Easy inventory management", checked: true },
                  { text: "Real-time Analytics", checked: true },
                  { text: "Simplified Shipment Creation", checked: true },
                  { text: "Secure Data Encryption", checked: true },
                ].map((item) => (
                  <div className={styles.checklistItem} key={item.text}>
                    <IconCheckCircle />
                    <p>{item.text}</p>
                  </div>
                ))}
              </Flex>
            </Flex>

            <Flex direction="column" align="center" style={{width:"100%"}} gap={4}>
              <Button type="primary" onClick={handleConnect} block>
                Connect to Amazon now
                <IconArrow />
              </Button>
              <Flex gap={4} align="center" style={{color: "var(--sentiment-text-info);"}}>
                <IconLock size={16} />
                <p>Your data is secure and we never store any sensitive information.</p>
              </Flex>
            </Flex>
          </div>
        </Modal>
      </div>}
    </>
  );
}
